import { Link } from "react-router-dom";
import { useMobileStyles } from "./MobileStyles";
import INavigationLink from "../../../models/navigation/INavigationLink";

interface IMobileLink {
    area?: string;
    link: INavigationLink;
    onNavigate: () => void;
}

const MobileLink = (props: IMobileLink) => {
    const { link } = props;
    const styles = useMobileStyles();

    const path = props.area
        ? `/${props.area}/${link.path}`
        : `/${link.path}`;

    return (
        <Link to={path} className={styles.link} onClick={props.onNavigate}>
            {link.title}
        </Link>
    );
}

export default MobileLink;